/**
 * @generated SignedSource<<1a52decd4a9a85887f0f51526eaaa052>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CLIENT_CONTACT_STATUS = "ACTIVE" | "INACTIVE" | "%future added value";
export type CreateClientContactInput = {
  clientId: string;
  firstName: string;
  lastName: string;
  email: string;
  jobTitle?: string | null;
  phone?: string | null;
  isGuestUser?: boolean | null;
  projectIds?: ReadonlyArray<string | null> | null;
  status?: CLIENT_CONTACT_STATUS | null;
  hubspotContactId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateClientContactMutation$variables = {
  input: CreateClientContactInput;
};
export type CreateClientContactMutation$data = {
  readonly createClientContact: {
    readonly clientContact: {
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly email: string | null;
        readonly jobTitle: string | null;
        readonly phone: string | null;
        readonly status: CLIENT_CONTACT_STATUS | null;
        readonly isGuestUser: boolean | null;
        readonly client: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly company: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly projects: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type CreateClientContactMutation = {
  variables: CreateClientContactMutation$variables;
  response: CreateClientContactMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateClientContactPayload",
    "kind": "LinkedField",
    "name": "createClientContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientContactEdge",
        "kind": "LinkedField",
        "name": "clientContact",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientContact",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isGuestUser",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v2/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateClientContactMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateClientContactMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "01c81b382a4f101b83e876a1ef26f64f",
    "id": null,
    "metadata": {},
    "name": "CreateClientContactMutation",
    "operationKind": "mutation",
    "text": "mutation CreateClientContactMutation(\n  $input: CreateClientContactInput!\n) {\n  createClientContact(input: $input) {\n    clientContact {\n      cursor\n      node {\n        id\n        firstName\n        lastName\n        email\n        jobTitle\n        phone\n        status\n        isGuestUser\n        client {\n          id\n          name\n        }\n        company {\n          id\n          name\n        }\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a2f9c0783215fc023706857d7a4feae";

export default node;
